<template>
  <v-col class="ma-0 pa-0" cols="12">
    <v-row class="ma-0 pa-0" justify="space-between">
      <v-col class="ma-0 pa-0 mt-4 mb-2" cols="auto" align="left"
             style="font-weight:bold;">
        {{item.customerName}}
      </v-col>
      <!-- <v-col class="ma-0 pa-0 mt-4 mb-2" cols="auto"
        v-if="authorities.ADD_STORE_GROUP">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn id="back_clean_btn1" class="back_clean_btn ma-0 pa-0"
              width="2rem" height="2rem" v-bind="attrs" v-on="on">
              <v-img height="2rem" width="2rem" class="ma-0 pa-0"
                src="@/assets/images/more_black.png"></v-img>
            </v-btn>
          </template>
          <v-list class="ma-0 pa-0" dense>
            <v-list-item>
              <v-list-item-title align="left"
                style="color:#707070;">{{ tsc('addToStoreGroup') }}</v-list-item-title>
            </v-list-item>
            <v-divider id="middle_divider" class="ma-0 pa-0"></v-divider>
            <template v-for="(store, idx) in $store.state.userData.storeGroupList">
              <v-list-item :key="idx">
                <v-list-item-title align="left" @click="addToGroup(item, store)">{{ store.groupName }}</v-list-item-title>
              </v-list-item>
            </template>
            <v-divider id="middle_divider" class="ma-0 pa-0"></v-divider>
            <v-list-item @click="goCreateStoreGroup(item)">
              <v-list-item-title align="left">{{ tsc('createAndAddGroup') }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col> -->
    </v-row>
    <v-row class="ma-0 pa-0" align="start">
      <v-col class="ma-0 pa-0" id="data_box" v-if="item.numberOfUas == 0 || !authorities.GET_STORE_GROUP">
        <v-row class="ma-0 pa-0" style="height: 11.45rem;"></v-row>
      </v-col>
      <v-col id="data_box" class="ma-0 pa-0" cols="3"
             style="cursor: pointer; height: 11.45rem;" @click="goStoreAnalyze(item)"
             v-else-if="item.numberOfUas != 0 && authorities.GET_STORE_GROUP">
        <v-col class="ma-0 pa-3 pl-5 pr-5" cols="12">
          <v-col class="ma-0 pa-0 mb-1" cols="12">
            <v-row class="ma-0 pa-0" align="center" justify="space-between"
                   style="font-weight:bold;">
              <v-col id="data_sub_title" class="ma-0 pa-0" cols="auto">
                {{tsc('last30DaysVisitors')}}
              </v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-row class="ma-0 pa-0" align="center"
                       style="color: #008DD0;font-size:0.8rem;">
                  {{tsc('viewAnalyze')}}
                  <v-img max-height="0.8rem" max-width="0.8rem" class="ma-0 pa-0 ml-2"
                         src="@/assets/images/blue_right_icon.png"></v-img>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col id="data_people_box" class="ma-0 pa-0" cols="12">
            <v-row class="ma-0 pa-0" align="center">
              <v-col class="ma-0 pa-1" cols="6">
                <v-col id="data_sub_title" class="ma-0 pa-0 pl-2" cols="12"
                       align="left">{{t('all')}}</v-col>
                <v-col id="data_count" class="ma-0 pa-0 pl-2" cols="12"
                       align="left">{{totalCount.total + tsc('peopleCount')}}</v-col>
              </v-col>
              <v-col class="ma-0 pa-1" cols="6">
                <v-col id="data_sub_title" class="ma-0 pa-0 pl-2" cols="12"
                       align="left">{{tsc('faceRecognition')}}</v-col>
                <v-col id="data_count" class="ma-0 pa-0 pl-2" cols="12"
                       align="left">{{totalCount.known + tsc('peopleCount')}}</v-col>
              </v-col>
            </v-row>
          </v-col>
        </v-col>
        <v-col class="ma-0 pa-0 pr-2 pb-3" cols="12" style="position: relative">
          <BarChart :chart-data="visitorDataset" :options="chartOptions"
                    :height="75"></BarChart>
          <v-col id="no_data" class="ma-0 pa-0" cols="12"
                 v-if="fetchLoading === false && visitorDataset.datasets[0].data.length === 0">
            {{t('noData')}}
          </v-col>
        </v-col>
      </v-col>
      <v-col class="ma-0 pa-0 pl-4" cols="9"
             v-if="authorities.GET_RECORDING_SUB_BRANCH">
        <v-col id="data_box" class="ma-0 pa-0" cols="12"
               style="cursor: pointer;" @click="goStoreCCTV(item)">
          <v-col class="ma-0 pa-3 pl-5 pr-5 pb-4" cols="12">
            <v-row class="ma-0 pa-0 mb-1" align="center" justify="space-between"
                   style="font-weight:bold;">
              <v-col id="data_sub_title" class="ma-0 pa-0" cols="auto">
                {{tsc('camera')}}
              </v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-row class="ma-0 pa-0" align="center"
                       style="color: #008DD0;font-size:0.8rem;">
                  {{tsc('viewCameras')}}
                  <v-img max-height="0.8rem" max-width="0.8rem" class="ma-0 pa-0 ml-2"
                         src="@/assets/images/blue_right_icon.png"></v-img>
                </v-row>
              </v-col>
            </v-row>
            <!-- 4개 이하의 camera 썸네일 표현 , 4개 초과의 camera일때 item.storeCameras 4개로 잘라버리기 -->
            <v-row class="ma-0 pa-0" v-if="item.storeCameras != undefined && item.storeCameras.length != 0">
              <v-row class="ma-0 pa-0" align="center">
                <v-col v-for="(item_nest, index_nest) in item.storeCameras"
                       :key="index_nest" class="ma-0 pa-0 pr-1 pb-1" cols="3">
                  <v-img v-if="item_nest.thumbnail != undefined && item_nest.isUas == false" height="8rem"
                         max-width="100%" class="ma-0 pa-0" style="background:grey;"
                         :src="item_nest.thumbnail" @error="thumbnailError('no_data_box_' +item_nest.unisCustomerCd + '_' + index_nest)">
                    <!-- 썸네일 에러일 경우 no data -->
                    <v-col :id="'no_data_box_' + item_nest.unisCustomerCd + '_' + index_nest" class="ma-0 pa-0 no_data_box_style">
                      {{t('noData')}}
                    </v-col>
                  </v-img>
                  <v-col v-else-if="item_nest.thumbnail == undefined && item_nest.isUas == false"
                         class="ma-0 pa-0" style="height: 8rem; line-height:8rem; text-align:center; background:grey;">
                    <p style="white-space:pre-wrap;font-size:0.85rem;">
                      {{t('notStreaming')}}
                    </p>
                  </v-col>
                </v-col>
              </v-row>
            </v-row>
            <v-row v-else class="ma-0 pa-0" align="center" justify="center" style="height:8rem;">
              {{t('noData')}}
            </v-row>
          </v-col>
        </v-col>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import mixin from '@/mixin';
import BarChart from '@/components/barChart';
export default {
  props: {
    item: Object,
    authorities: Object,
    visitorDataset: Object,
    chartOptions: Object,
    totalCount: Object,
    fetchLoading: Boolean,
    currentGroupId: String,
  },
  components: {
    BarChart
  },
  mixins: [mixin.common],
  data: () => ({

  }),
  methods: {
    tsc(t) {
      return this.$t("lang.storeSearch." + t);
    },
    tsg(t) {
      return this.$t("lang.group." + t);
    },
    async addToGroup(storeData, item) {
      let storeList = item.stores;
      let duplicated = false;
      this.$vloading.show();
      storeList.forEach((i) => {
        if(i.unisCustomerCd == storeData.unisCustomerCd) {
          duplicated = true;
        }
      });
      if(duplicated) { //이미 그룹에 속해 있는 경우
        this.showToastMessage(this.tmb('storeAlreadyAdded'));
        this.$vloading.hide();
      } else {
        storeList.push({customerName: storeData.customerName, unisCustomerCd: storeData.unisCustomerCd});
        let params = {
          groupName: item.groupName,
          stores: storeList,
        };
        await this.networkController.updateStoreGroup(params, item.id)
          .then(async (res) => {
            this.showToastMessage(this.tmb('requestSuccess'));
            this.$vloading.hide();
          }).catch(error => {
            this.showToastMessage(this.tmb('requestFail'));
            this.$vloading.hide();
          });
      }
    },
    goCreateStoreGroup(item) {
      this.$store.commit('setSelectedStoreMakeStoreGroup', item);
      this.pushRoute('/store-group/create', {});
    },
    goStoreAnalyze(store) {
      this.$store.commit('setStoreData', store);
      this.pushRoute('/store-search/store-analyze', {
        unisCustomerCd: store.unisCustomerCd, groupId: this.currentGroupId
      });
    },
    goStoreCCTV(store) {
      this.$store.commit('setStoreData', store);
      this.pushRoute('/store-search/store-cctv', {
        unisCustomerCd : store.unisCustomerCd, groupId: this.currentGroupId
      });
    },
    thumbnailError(idName) { //thumbnail을 못 가져올 경우 no data 표시하도록 활성화
      document.getElementById(idName).style.display='block';
    },
  }
}
</script>

<style lang="scss" scoped>
#data_box {
  background-color: #34363C;
  border-radius: 4px;
}
#data_people_box {
  background-color: #5C5D62;
  border-radius: 4px;
}
#data_sub_title {
  color: #CECED0;
  font-size: 0.8rem;
}
#data_count {
  font-weight: bold;
}
#middle_divider {
  background-color: #4C4C4C;
}
.back_clean_btn {
  background-color: transparent !important;
  min-width: 1rem !important;
  color: white;
}
.no_data_box_style{
  height: 8rem;
  line-height: 8rem;
  text-align: center;
  background: grey;
  color: white;
  display: none;
}
#no_data {
  font-size: 0.8rem;
  position: absolute;
  z-index: 2;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -35%);
}
.v-list {
  background: #171921 !important;
  border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item{
    color: white !important;
  }
  .v-list-item__content{
    color: white;
  }
}
</style>